import {
  axiosGetWithCookies,
  axiosPatchWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';
import { startOfDay } from 'utils/time';

export const fetchSecurityCompanies = ({ region, from, search, archived }) => {
  let query = `/users/security-companies?limit=50`;

  if (region)
    query += region.id ? `&regionId=${region.id}` : `&regionId=${region}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (archived) query += `&includeArchived=${archived}`;

  return axiosGetWithCookies(query);
};
export const fetchSecurityCompanyById = id =>
  axiosGetWithCookies(`/users/security-companies/${id}`);
export const fetchSecurityCompanyServicesById = id =>
  axiosGetWithCookies(`/users/security-companies/${id}/limited`);

export const fetchPendingSecurityCompanies = ({
  status,
  country,
  dateReceived,
  timezone,
  from,
}) => {
  let query = `/regions/company-sign-up?limit=50`;
  if (country) query += `&country=${country}`;
  if (status) query += `&status=${status}`;
  if (dateReceived) {
    const date = startOfDay({
      date: dateReceived,
      timezone: timezone || 'UTC',
    });
    query += `&dateReceived=${date}`;
  }
  if (from) query += `&from=${from}`;
  return axiosGetWithCookies(query);
};

export const fetchPendingCompanyDetail = id => {
  return axiosGetWithCookies(`/regions/company-sign-up/${id}`);
};
export const createPendingCompany = pendingCompany =>
  axiosPostWithCookies('/regions/company-sign-up', {
    data: pendingCompany,
  });
export const rejectPendingCompany = id => {
  return axiosPatchWithCookies(`/regions/company-sign-up/${id}/reject`);
};
export const approvePendingCompany = ({
  id,
  region,
  subscriptions,
  trialLength,
  trialAutoExtendLength,
}) => {
  //add the trial auto extension length here.
  let query = `/regions/company-sign-up/${id}/approve?trialLength=${trialLength}&trialAutoExtendLength=${trialAutoExtendLength}`;

  if (subscriptions && Array.isArray(subscriptions)) {
    /* eslint-disable no-param-reassign */
    query += subscriptions.reduce(
      (acc, s) => (acc += `&subscription=${s}`),
      '',
    );
  }

  if (region) query += `&region=${region}`;

  return axiosPatchWithCookies(query);
};

export const fetchSecurityCompanyBillingInfo = () =>
  axiosGetWithCookies(`/users/security-companies/billing/info`);

export const fetchSecurityCompanyBillingSetupInfo = () =>
  axiosGetWithCookies(`/users/security-companies/billing/setup`);

export const fetchAllAvailablePlans = value => {
  let query = `/users/security-companies/billing/available-plans`;
  if (value && value !== '') {
    query += `?region=${value}`;
  }
  return axiosGetWithCookies(query);
};

export const changeSubscription = ({ data }) =>
  axiosPostWithCookies(
    `/users/security-companies/billing/subscription/request`,
    { data },
  );

export const updateSecurityCompany = (id, securityCompany) =>
  axiosPutWithCookies(`/users/security-companies/${id}`, {
    data: securityCompany,
  });

export const cancelSubscription = ({ data }) =>
  axiosPostWithCookies(
    `/users/security-companies/billing/cancel-subscription/request`,
    { data },
  );

export const costEstimate = ({ data }) =>
  axiosPostWithCookies(`/users/security-companies/billing/calculate-cost`, {
    data,
  });
